export const ErrorChanelEnum = {
  QA: 'qa',
  CONTENT: 'content'
} as const;

export type ErrorChanelType = typeof ErrorChanelEnum[keyof typeof ErrorChanelEnum];

export class BaseError extends Error {
  chanel: ErrorChanelType;
  type: string;
  name: string;
}
